<ion-toggle class="mt-2" [(ngModel)]="isToggleChecked" (ngModelChange)="toggleTheme()"></ion-toggle>
